import { z, ZodType } from 'zod';
import { DashboardPeriod, dashboardPeriodSchema } from './dashboard-series';

export type DashboardSummaryParams = {
	currency: string;
	timeZone: string;
	period: DashboardPeriod;
};

export type DashboardSummaryMetric = {
	key: string;
	total: number;
};

export const dashboardSummaryMetricSchema: ZodType<DashboardSummaryMetric> = z.object({
	key: z.string(),
	total: z.number(),
});

export type DashboardSummaryResponse = {
	period: DashboardPeriod;
	currency: string;
	from: string;
	to: string;
	metrics: DashboardSummaryMetric[];
};

export const dashboardSummaryResponseSchema: ZodType<DashboardSummaryResponse> = z.object({
	period: dashboardPeriodSchema,
	currency: z.string(),
	from: z.string(),
	to: z.string(),
	metrics: dashboardSummaryMetricSchema.array(),
});
